let swiperReady;

function loadSwiper() {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (swiperReady) return swiperReady;

  swiperReady = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="swiper-bundle.min.js"]');
    const script = existing || document.createElement('script');
    const timeout = setTimeout(() => reject(new Error('Swiper load timed out')), 10000);
    script.addEventListener('load', () => {
      clearTimeout(timeout);
      if (window.Swiper) resolve(window.Swiper);
      else reject(new Error('Swiper unavailable'));
    }, { once: true });
    script.addEventListener('error', () => {
      clearTimeout(timeout);
      reject(new Error('Swiper unavailable'));
    }, { once: true });
    if (!existing) {
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.async = true;
      document.head.appendChild(script);
    }
  });
  return swiperReady;
}

class ProductBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.mobile = window.matchMedia('(max-width: 749px)');
    this.viewport = this.querySelector('.product-before-after__viewport');
    this.mobile.addEventListener('change', () => this.update(), { signal });
    this.viewport.addEventListener('keydown', (event) => {
      if (!this.swiper || event.target !== this.viewport) return;
      const actions = {
        ArrowLeft: () => this.swiper.slidePrev(),
        ArrowRight: () => this.swiper.slideNext(),
        Home: () => this.swiper.slideTo(0),
        End: () => this.swiper.slideTo(this.swiper.slides.length - 1),
      };
      if (actions[event.key]) {
        event.preventDefault();
        actions[event.key]();
      }
    }, { signal });
    this.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('.before-after-card');
      const index = this.swiper ? [...this.swiper.slides].indexOf(card) : -1;
      if (index >= 0) this.swiper.slideTo(index, 0);
    }, { signal });
    this.update();
  }

  async update() {
    if (!this.mobile.matches) {
      this.swiper?.destroy(true, true);
      this.swiper = null;
      this.viewport.removeAttribute('tabindex');
      return;
    }
    this.viewport.tabIndex = 0;
    if (this.swiper) return;
    try {
      const Swiper = await loadSwiper();
      if (!this.isConnected || !this.mobile.matches || this.swiper) return;
      this.querySelector('.product-before-after__grid').scrollLeft = 0;
      this.swiper = new Swiper(this.viewport, {
        wrapperClass: 'product-before-after__grid',
        slideClass: 'before-after-card',
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchOverflow: true,
        grabCursor: true,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
        scrollbar: {
          el: this.querySelector('.product-before-after__scrollbar'),
          draggable: true,
          hide: false,
          snapOnRelease: true,
        },
        a11y: { slideLabelMessage: '{{index}} van {{slidesLength}}' },
      });
    } catch {
      // Native horizontal scrolling remains available if the shared CDN fails.
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('product-before-after')) {
  customElements.define('product-before-after', ProductBeforeAfter);
}
